export const headers = [
  { name: 'Titulo', field: 'title', sortable: true },
  { name: 'Arquivo', field: 'file', sortable: false, custom: true },
  { name: 'Tipo', field: 'type', sortable: false, custom: true },
  { name: 'Valido até', field: 'valid_at', sortable: false, custom: true },
  { name: 'Ações', field: 'actions', sortable: false }
]
